import { Route } from "@opstel/query/v2/models/route";
import { inputValueChangeHandler, CheckboxModelValue } from "@shared/lion";
import { useState } from "react";

interface RouteSelectionProps {
  readonly routes: Route[];
  readonly currentRouteId: string | undefined;
  readonly onRouteChange: (routeId: string) => void;
}

export function RouteSelection({ routes, currentRouteId, onRouteChange }: RouteSelectionProps) {
  const [usingPreferenceState, setUsingPreferenceState] = useState(
    currentRouteId === routes[0]?.id,
  );

  const handlePreferenceChange = inputValueChangeHandler<CheckboxModelValue>((value) => {
    setUsingPreferenceState(value.checked);
    if (value.checked) {
      onRouteChange(routes[0]?.id);
    }
  });

  if (routes.length === 0) return undefined;

  return (
    <>
      <tractie-checkbox
        name="Preference route"
        label="Voorkeursrijweg"
        modelValue={{ checked: usingPreferenceState }}
        onmodel-value-changed={handlePreferenceChange}
      />
      {!usingPreferenceState && (
        <tractie-select
          label="Route"
          name="route"
          modelValue={currentRouteId}
          onmodel-value-changed={inputValueChangeHandler<string>(onRouteChange)}
        >
          <select slot="input">
            {!currentRouteId && <option>Onbekende route</option>}
            {routes.map((route) => (
              <option key={route.id} value={route.id}>
                {`${route.preference}: ${route.tracks.join(", ")}`}
              </option>
            ))}
          </select>
        </tractie-select>
      )}
    </>
  );
}
